import Factory from '../utils/factory'

export default Factory({
  id: null,
  name: null,
  description: null,
  image: null,
})
